import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';

import AccountIcon from '@material-ui/icons/AccountCircle';
import EditIcon from '@material-ui/icons/Edit';

import EditImageDialog from 'app/components/dialogs/EditImageDialog';
import EditUserFileDialog from 'app/components/drive/EditUserFileDialog';

import useApi from 'app/context/useApi';

const useStyles = makeStyles(theme => ({
    container: {
        textAlign: 'center'
    },
    avatarContainer: {
        position: 'relative',
        display: 'inline-block',
        marginBottom: theme.spacing(3)
    },
    bigAvatar: {
        width: 150,
        height: 150,
        fontSize: '100px',
    },
    editButton: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: 150,
        height: 150,
        zIndex: 2,
        fontSize: 50,
        opacity: 0,
        transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        color: '#ffffff',

        ['&:hover']: {
            opacity: 0.8,
            backgroundColor: 'rgba(0, 0, 0, 0.24)'
        }
    },
    chip: {
        marginLeft: theme.spacing(1)
    }
}));

export default function Snapshot(props) {

    const { urlPrefix, user } = props;
    const api = useApi();

    const [ avatar, setAvatar ] = useState(null);

    const [ editFileDialogOpen, setEditFileDialogOpen ] = useState(false);
    const [ editImageDialogOpen, setEditImageDialogOpen ] = useState(false);

    const classes = useStyles();

    useEffect(() => {
        if (user) setAvatar(user.avatar);
    }, [user]);

    const editImage = () => {
        if (avatar) {
            setEditImageDialogOpen(true);
        } else {
            setEditFileDialogOpen(true);
        }
    }

    // Edit File Dialog

    const closeEditFileDialog = () => {
        setEditFileDialogOpen(false);
    }

    const closeEditFileDialogAndEditImage = (avatar) => {
        closeEditFileDialog();
        setAvatar(avatar);
        api.post(urlPrefix + '/picture', {id: avatar.id});
    }

    const editFileDialogClosed = () => {
        setEditImageDialogOpen(true);
    }

    // Edit Image Dialog

    const closeEditImageDialog = () => {
        setEditImageDialogOpen(false);
    }

    const closeEditImageDialogAndRefresh = (avatar) => {
        closeEditImageDialog();
        setAvatar(avatar);
    }

    return user ? (
        <div className={classes.container}>
            <div className={classes.avatarContainer}>
                <Avatar src={avatar ? avatar.full_url : null} className={classes.bigAvatar}>
                    <AccountIcon fontSize='inherit' />
                </Avatar>
                <IconButton className={classes.editButton} onClick={editImage}>
                    <EditIcon fontSize='inherit' />
                </IconButton>
            </div>
            <Typography variant="h6" component="h2" align="center">
                {user.first + ' ' + user.last}
            </Typography>
            <Typography variant="subtitle2" color="secondary" align="center">
                {user.membership_title}{user.is_online && <Chip size="small" label="ONLINE" color="secondary" className={classes.chip}/>}
            </Typography>
            <EditUserFileDialog
                open={editFileDialogOpen}
                onSave={closeEditFileDialogAndEditImage}
                onClose={closeEditFileDialog}
                onClosed={editFileDialogClosed}
                urlPrefix={urlPrefix}
            />
            {avatar &&
                <EditImageDialog
                    file={avatar}
                    serverUrl={urlPrefix + "/file/edit/image"}
                    open={editImageDialogOpen}
                    onSave={closeEditImageDialogAndRefresh}
                    onClose={closeEditImageDialog}
                    urlPrefix={urlPrefix}
                />
            }
        </div>
    ) : null;
}
